import Layout from './Layout';
import Auth from './Auth';
import Dashboard from './Dashboard';

export default {
  Auth,
  Layout,
  Dashboard
};